<h2 mat-dialog-title>{{appli.reference}} - {{applicationStatus}}</h2>
<mat-dialog-content>

    <h4>Application Details:</h4>
    <div class="reduced-margin bordered">
        <table>
            <tr>
                <th><span>Status (<u>{{displayModel().application.status}}</u>):</span></th>
                <td><span>{{displayModel().application.statusDescription}}</span></td>
            </tr>
            <tr>
                <th><span>Original Capital Amount:</span></th>
                <td><span>R{{displayModel().application.baseAmount | number}}</span></td>
            </tr>
            <tr>
                <th><span>Instalment:</span></th>
                <td><span>R{{displayModel().application.instalment | number}}</span></td>
            </tr>
            <tr>
                <th><span>No. of Installments:</span></th>
                <td><span>{{displayModel().application.noInstallments}}</span></td>
            </tr>
            <tr>
                <th><span>Start Date:</span></th>
                <td><span>{{displayModel().application.startDate | date:'dd/MM/yyyy'}}</span></td>
            </tr>
        </table>
    </div>

    <mat-divider class="w-75 m-05-auto"></mat-divider>

    <h4>Customer: <strong>{{displayModel().customer.initals }}</strong></h4>

    <div class="reduced-margin bordered">
        <table>
            <tr>
                <th><span>ID Type:</span></th>
                <td><span>{{displayModel().customer.idType}}</span></td>
            </tr>
            <tr>
                <th><span>{{ displayModel().customer.idTitle }}:</span></th>
                <td><span>{{ displayModel().customer.idValue }}</span></td>
            </tr>
            <tr>
                <th><span>Full Name:</span></th>
                <td><span>{{displayModel().customer.fullName}}</span></td>
            </tr>
            <tr>
                <th><span>Email:</span></th>
                <td><span>{{displayModel().customer.email}}</span></td>
            </tr>
            <tr>
                <th><span>Mobile Number:</span></th>
                <td><span>{{displayModel().customer.mobileNo}}</span></td>
            </tr>
            <tr>
                <th><span>Address:</span></th>
                <td><span>{{displayModel().customer.address}}</span></td>
            </tr>
        </table>
    </div>

    <mat-divider class="w-75 m-05-auto"></mat-divider>

    <h4>Employment Information</h4>

    <div class="reduced-margin bordered">
        <table>
            <tr>
                <th><span>Employer:</span></th>
                <td><span>{{displayModel().employment.employer}}</span></td>
            </tr>
            <tr>
                <th><span>Employee No.:</span></th>
                <td><span>{{displayModel().employment.employeeNo}}</span></td>
            </tr>
            <tr>
                <th><span>Branch:</span></th>
                <td><span>{{displayModel().employment.branchName}}</span></td>
            </tr>
            <tr>
                <th><span>Address:</span></th>
                <td><span>{{displayModel().employment.address}}</span></td>
            </tr>
            <tr>
                <th><span>Employment Status:</span></th>
                <td><span>{{displayModel().employment.employmentStatus}}</span></td>
            </tr>
            <tr>
                <th><span>Job Title:</span></th>
                <td><span>{{displayModel().employment.jobTitle}}</span></td>
            </tr>
            <tr>
                <th><span>Start Date:</span></th>
                <td><span>{{displayModel().employment.startDate | date:'dd/MM/yyyy'}}</span></td>
            </tr>
            <tr>
                <th><span>Pay Day:</span></th>
                <td><span>{{displayModel().employment.payDay}}</span></td>
            </tr>
            <tr>
                <th><span>Pay Frequency:</span></th>
                <td><span>{{displayModel().employment.payFrequency}}</span></td>
            </tr>
        </table>
    </div>

    <mat-divider class="w-75 m-05-auto"></mat-divider>

    <h4>Bank Information</h4>
    <div class="reduced-margin bordered">
        <table>
            <tr>
                <th><span>Bank:</span></th>
                <td><span>{{displayModel().bank.name}}</span></td>
            </tr>
            <tr>
                <th><span>Status (<u>{{displayModel().bank.status}}</u>):</span></th>
                <td><span>{{displayModel().bank.statusLong}}</span></td>
            </tr>
            <tr>
                <th><span>Branch Code:</span></th>
                <td><span>{{displayModel().bank.branchCode}}</span></td>
            </tr>
            <tr>
                <th><span>Account Type:</span></th>
                <td><span>{{displayModel().bank.accountType}}</span></td>
            </tr>
            <tr>
                <th><span>Account Number:</span></th>
                <td><span>{{displayModel().bank.accountNo}}</span></td>
            </tr>
        </table>
    </div>

    <mat-divider class="w-75 m-05-auto"></mat-divider>

</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>